import { createSelector } from 'reselect';
import { EEventState, EBetOfferTag } from '../../utils/enums';
import { AppUISelectors } from '../app-ui';
import { UserContextSelectors } from '../user';

/**
 *
 * @param state
 * @return {IAppDataState}
 */
export const selectAppData = state => state.appData;
export const selectUniqueKeyToGroupDetails = state => state.appData.uniqueKeyToGroupDetails;
export const selectSportGroups = state => state.appData.sportGroups;
/**
 *
 * @param state
 * @return {ISportsMap}
 */
export const selectSportsMap = state => state.appData.sportsMap;
/**
 *
 * @param state
 * @return {IEventsMap}
 */
export const selectEventsMap = state => state.appData.eventsMap;
/**
 *
 * @param state
 * @return {IBetOffersMap}
 */
export const selectBetOffersMap = state => state.appData.betOffersMap;
/**
 *
 * @param state
 * @return {IOutcomesMap}
 */
export const selectOutcomesMap = state => state.appData.outcomesMap;
/**
 *
 * @param state
 * @return {IParticipantsMap}
 */
export const selectParticipantsMap = state => state.appData.participantsMap;
/**
 *
 * @param state
 * @param props
 * @return {ISport}
 */
export const selectSportById = (state, props) => state.appData.sportsMap[props.sportId];
/**
 *
 * @param state
 * @param props
 * @return {ISport}
 */
export const selectSportGroupById = (state, props) => state.appData.sportGroups[props.sportId];
/**
 *
 * @param state
 * @param props
 * @return {ILiveEvent}
 */
export const selectEventById = (state, props) => state.appData.eventsMap[props.eventId];
/**
 *
 * @param state
 * @param props
 * @return {IBetOffer}
 */
export const selectBetOfferById = (state, props) => state.appData.betOffersMap[props.betOfferId];
/**
 *
 * @param state
 * @param props
 * @return {IOutcome}
 */
export const selectOutcomeById = (state, props) => state.appData.outcomesMap[props.outcomeId];
/**
 *
 * @param state
 * @param props
 * @return {IParticipant}
 */
export const selectParticipantById = (state, props) => state.appData.participantsMap[props.participantId];
export const selectBetOfferOutcomeIds = createSelector([selectBetOfferById], (betOffer) => betOffer.outcomes);
export const selectBetOfferOutcomes = createSelector(
  [selectBetOfferOutcomeIds, selectOutcomesMap],
  (ids, outcomesMap) => ids.map((id) => outcomesMap[id])
);

export const makeSelectOutcomeOddsByOutcomeId = () => {
  return createSelector(
    [selectOutcomeById],
    (outcome) => outcome.odds
  );
};

export const makeSelectBetOfferEachWayTerms = () => {
  return createSelector([selectBetOfferById], (betOffer) => betOffer.eachWayTerms);
};

export const makeSelectBetOfferIsSuspended = () => {
  return createSelector([selectBetOfferById], (betOffer) => betOffer.suspended);
};

export const makeSelectBetOfferIsStartingPrice = () => {
  return createSelector([selectBetOfferById], (betOffer) => betOffer.tags.includes(EBetOfferTag.STARTING_PRICE));
};

export const makeSelectIsEventStreamed = () => {
  return createSelector([selectEventById, AppUISelectors.selectIsMobileLook],
    (liveEvent, isMobileLook) => liveEvent && liveEvent.event && (isMobileLook ? liveEvent.event.isStreamedMobile : liveEvent.event.isStreamedWeb)
  );
};

export const makeSelectIsEventBOG = () => {
  return createSelector([selectEventById, UserContextSelectors.selectIsBOGCountry],
    (liveEvent, isBOGCountry) => liveEvent && liveEvent.event && liveEvent.event.isBOGEvent && isBOGCountry
  );
};

export const makeSelectHasEventStarted = () => {
  return createSelector([selectEventById],
    (liveEvent) => liveEvent && liveEvent.event && liveEvent.event.state === EEventState.STARTED
  );
};
